import { Box, Button, CircularProgress, Stack } from "@mui/material";
import { GlobalState } from "context/GlobalContext";
import React, { useEffect, useState } from "react";
import { pythonVmInstance } from "utils/AxiosInstances/RareboxPythonInstance";
import FileSaver from "file-saver";
import { filterColArry } from "./data";
import { DownloadRounded } from "@mui/icons-material";
import RenderInputField from "components/CustomQueriesDashboard/ReusableComponents/RenderInputField/RenderInputField";
import { constraintsOptions, getColDefaultValue, isColumnDefault } from "data/globalData";
import parseErrMsgFromError from "utils/errorFunctions/parseErrorMessageFromError";
const Git = () => {
	const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();
	const [loading, setLoading] = useState(false);

	const defaultData = filterColArry?.reduce((acc, row) => {
		acc[row.key] = getColDefaultValue(row);
		return acc;
	}, {});
	const [filterData, setFilterData] = useState({ ...defaultData });
	const handleRunQueryClick = async (e) => {
		e.preventDefault();
		setLoadingOpen(true);
		let pendingFields = [];
		filterColArry?.forEach((attr) => {
			if (isColumnDefault(attr, filterData?.[attr?.key]) && attr?.constraints?.[constraintsOptions.NOTNULL.key] === true)
				pendingFields.push(attr);
		});

		if (pendingFields?.length) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Enter values for ${pendingFields.map((row) => row?.name)}`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
			return;
		}
		await pythonVmInstance({
			url: `/custom_queries/git/download`,
			headers: {
				"Content-Type": "application/json",
			},
			method: "post",
			data: filterData,
			responseType: "blob",
		})
			.then((res) => {
				const url = URL.createObjectURL(res.data);
				FileSaver.saveAs(url, `git_${new Date().toISOString().split("T")[0]}.csv`);
				setLoadingOpen(false);
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: "Downloaded the file",
					severity: "success",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
			})
			.catch((err) => {
				console.log(err);
				setSnackBarOpen(true);
				setLoadingOpen(false);
				setSnackBar({
					...snackBar,
					message: parseErrMsgFromError(err),
					severity: "error",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
			});
	};

	return (
		<Stack spacing={2} component="form" onSubmit={handleRunQueryClick} pt={1}>
			{/* <Typography variant="h6">Inventory Snapshot Download</Typography> */}
			{/* <Typography variant="subtitle1" pt={2}> */}
			{/* Last synced with UC: {sync} */}
			{/* ⚠️ Temporary Unavailability <br />
                UC is currently updating their internal structure. The report download feature is temporarily unavailable. We
                appreciate your patience! */}
			{/* </Typography> */}

			<Box display="flex" columnGap={2} flexWrap={"wrap"} justifyContent={""} rowGap={2}>
				{filterColArry?.map((col) => {
					return (
						<RenderInputField
							column={col}
							data={filterData}
							setData={setFilterData}
							selectOptObjName={"select_options"}
							width={"20%"}
							longWidth={"300px"}
							disabled={false}
							// error={errObj?.[column.key] ? true : false}
							// setError={setErrorObj}
							// dependencyColData={}
							disableLabel={true}
						/>
					);
				})}

				<Box alignSelf="flex-end" pb={1}>
					<Button
						variant="contained"
						sx={{ width: "200px" }}
						type="submit"
						disabled={loading}
						startIcon={loading ? <CircularProgress color="inherit" size="20px" /> : <DownloadRounded />}>
						{loading ? "Loading..." : "Download"}
					</Button>
				</Box>
			</Box>
		</Stack>
	);
};

export default Git;
